export const items = {
    "australia": {
        title: "Holiday Trip in Australia",
        time: "2024.12.10 - 2024.12.21",
        text: "I visited Australia for winter holiday trip, AUS🇦🇺 is really a great place.",
        image: "https://raw.githubusercontent.com/Enqurance/Figures/main/202412141501520.jpg",
        alt: "aus",
        link: "/posts/2024/australia"
    },
    "japan_2024": {
        title: "Graduation Tour in Japan",
        time: "2024.7.2 - 2024.7.11",
        text: "I visited Japan with my friend for a graduation tour. We visited Kyoto and Kyushu.",
        image: "https://raw.githubusercontent.com/Enqurance/Figures/main/202412141521253.jpg",
        alt: "jp_2024",
        link: "/posts/2024/japan"
    },
    "vietnam": {
        title: "Weekend Tour in Vietnam",
        time: "2024.2.2 - 2024.2.6",
        text: "I visited Ho Chi Minh City and Nah Trang, Vietnam. I lost 180 USD here😭.",
        image: "https://raw.githubusercontent.com/Enqurance/Figures/main/202402232145382.jpg",
        alt: "vietnam",
        link: "/posts/2024/vietnam"
    },
    "singapore": {
        title: "My Stay in Singapore",
        time: "2023.12.9 - 2024.2.8",
        text: "I visited NTU, Singapore for an internship. I also enjoyed a coldplay show here.",
        image: "https://raw.githubusercontent.com/Enqurance/Figures/main/202402232139202.jpg",
        alt: "singapore",
        link: "/posts/2023/singapore"
    },
    "japan_2023": {
        title: "Trip to Japan",
        time: "2023.11.3 - 2023.11.12",
        text: "I went to Japan for the live show of Coldpalay and for a vacation.",
        image: "https://raw.githubusercontent.com/Enqurance/Figures/main/202312212358686.jpeg",
        alt: "Japan",
        link: "/posts/2023/japan"
    },
    "yantai": {
        title: "Trip to Yantai City",
        time: "2023.10.10 - 2023.10.12",
        text: "I went to Yantai City for a weekend tour. Beautiful see view here🌊~",
        image: "https://raw.githubusercontent.com/Enqurance/Figures/main/202401032014131.png",
        alt: "Yantai",
        link: "/posts/2023/yantai"
    },
    "malaysia": {
        title: "Trip to Kota Kinabalu, Malaysia🇲🇾",
        time: "2024.1.4 - 2024.1.6",
        text: "I went to Kota Kinabalu, Malaysia🇲🇾 for a weekend tour🏖~️",
        image: "https://raw.githubusercontent.com/Enqurance/Figures/main/202404202052953.jpeg",
        alt: "Malaysia",
        link: "/posts/2024/malaysia"
    },
    "changsha": {}
}
